import { GatewayService } from '../GatewayService';
import { PhicubeResponse } from '../interface/PhicubeResponse';
import { AppSession } from '../AppSession';
import { environment } from 'src/environments/environment';

export class CarteiraRecomendadaProvider {
    getCarteiras(): Promise<PhicubeResponse> {
        return new GatewayService().requestGet('/api/cr')
    }

    getHistorico(idCarteira): Promise<PhicubeResponse> {
        return new GatewayService().requestGet('/api/cr/' + idCarteira + "/history")
    }

    getDetail(idCarteira): Promise<PhicubeResponse> {
        return new GatewayService().requestGet('/api/cr/' + idCarteira)
    }

    async connectWebsocket() {
        return new WebSocket(`${environment.urlWebsocket}/multifeed/` + (await AppSession.getToken()).access_token);
    }
}